import { styled } from 'styled-components';

export const MenuItemHeader = styled.div`
  flex: 1;
  font-size: 1rem;
  font-weight: 600;
  font-family: ${(props) => props.theme.fonts.default};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-decoration: none;
  margin-bottom: 0.25rem;
`;

export const MenuItemSubHeader = styled.p`
  font-size: 0.875rem;
`;
